export const Assets = {
   
    SearchAvatar1: require("./images/SearchAvatar1.png"),

}